export default "__VITE_ASSET__c4f6b355__"